import { PortalCompetitionSession } from '@api/competitionsApi/interfaces';
import dayjs from 'dayjs';

export const UPCOMING_SESSIONS_SIDEBAR_LIMIT = 5;

export const filterUpcomingPortalSessions = (
  sessions: PortalCompetitionSession[]
): PortalCompetitionSession[] => {
  const now = dayjs();

  return sessions
    .filter((session) => {
      if (
        session.status === 'completed' ||
        session.status === 'not_held'
      ) {
        return false;
      }

      if (session.status === 'in_progress') {
        return true;
      }

      return !dayjs(session.heldOn).isBefore(now);
    })
    .sort((first, second) => {
      if (
        first.status === 'in_progress' &&
        second.status !== 'in_progress'
      ) {
        return -1;
      }

      if (
        second.status === 'in_progress' &&
        first.status !== 'in_progress'
      ) {
        return 1;
      }

      return first.heldOn.localeCompare(second.heldOn);
    });
};

export type PortalSessionsPartition = {
  upcoming: PortalCompetitionSession[];
  past: PortalCompetitionSession[];
};

export const partitionPortalSessions = (
  sessions: PortalCompetitionSession[]
): PortalSessionsPartition => {
  const upcoming = filterUpcomingPortalSessions(sessions);
  const upcomingIds = new Set(upcoming.map((session) => session.id));

  const past = sessions
    .filter((session) => !upcomingIds.has(session.id))
    .sort((first, second) => second.heldOn.localeCompare(first.heldOn));

  return { upcoming, past };
};
